import { calculateSumTaxes } from '@libs/calculateSumTaxes';
// import { calculateSumDiscound } from '@libs/calculateSumTaxes';

export const standardizeData = (paramData) => {
    let dataBySalesType = {};
    let sumTaxes = [];
    let sumSubTotal = 0;
    let sumGrandTotal = 0;
    let sumDiscount = [];

    // Sekarang paramData berupa object, bukan array
    // Asumsi struktur: { transaction_items, sub_total, grand_total, taxes }
    let { transaction_items, sub_total, grand_total, taxes, discounts } = paramData;

    if (Array.isArray(transaction_items)) {
        transaction_items.forEach((item) => {
            if (
                typeof dataBySalesType[item.sales_type] === 'object' &&
                Object.keys(dataBySalesType[item.sales_type]).length > 0
            ) {
                // UPDATE OLD BILL DATA
                dataBySalesType[item.sales_type].transaction_items.push(item);
            } else {
                // NEW BILL DATA FOR THIS TYPE SALES
                let insertData = {
                    transaction_items: [item],
                };
                dataBySalesType[item.sales_type] = { ...insertData };
            }
        });
    }

    sumTaxes = calculateSumTaxes(sumTaxes, taxes);
    sumSubTotal = sumSubTotal + (sub_total ? sub_total : 0);
    sumGrandTotal = sumGrandTotal + (grand_total ? grand_total : 0);
    // sumDiscount = calculateSumDiscound(sumDiscount, discounts);

    return {
        data: dataBySalesType,
        taxes: sumTaxes,
        sub_total: sumSubTotal,
        grand_total: sumGrandTotal,
        discounts: sumDiscount
    };
};